import React from 'react';
import PaymentSite from './PaymentSite';

function App() {
  return <PaymentSite />;
}

export default App;